var $ = jQuery;

// Mobile - dropdown
$(document).ready(function () {
  $(" .main-menu-toggle").on("click", function () {
    if ($(".header-mobile-container").hasClass('open')) {
      $('body').removeClass("modal-open");
      $("#header").removeClass("mobile-menu-open");
      mobile_menu_close();
    } else {
      $('body').addClass("modal-open");
      $("#header").addClass("mobile-menu-open");
      mobile_menu_open();
      // close lang menu
      lang_menu_close();
    }
  });
});


$(document).ready(function () {
  $('header.header-mega_menu .btn-country-select').on('click', function () {
    if ($('.header-mobile-country-select-container').hasClass('open')) {
      $('body').removeClass("modal-open");
      $("#header").removeClass("mobile-menu-open");
      lang_menu_close();
    } else {
      $('body').addClass("modal-open");
      $("#header").addClass("mobile-menu-open");
      mobile_menu_close();
      lang_menu_open();
    }
  });
});

// Mobile slide
$(document).ready(function () {
  $('header.header-mega_menu .header-mobile-container ul li.nav-item.has-sub-nav > a').on('click', function () {
    mobile_slide_left($(this));
  });

  $('header.header-mega_menu .header-mobile-container .nav-back').on('click', function () {
    mobile_slide_back($(this));
  });
});


function mobile_menu_open() {
  $(".main-menu-toggle").addClass("menu-open");
  $(".header-mobile-container").addClass('open');
  //add background effect
  var $header =  $('#header')
  if($header.hasClass('transparent')){
      var scroll = $(window).scrollTop();
      if (scroll < 2) {
        $header.addClass('scrolling');
      }   
   }
}

function mobile_menu_close() {

  var timedelay = 300;

  $(".main-menu-toggle").removeClass("menu-open");
  $(".header-mobile-container").removeClass('open sub-open');

  // header-mobile-container reset
  $('header.header-mega_menu .header-mobile-container ul li.nav-item').each(function () {
    $(this).removeClass('active');
  });

  $('.header-mobile-container').animate({
    scrollTop: $('.header-mobile-container').offset().top - 400 /// over set neg number to force to the top on any screen size
  }, timedelay);

  setTimeout(function () {
    $('header.header-mega_menu .header-mobile-container-inner').removeClass('slide-left').height('auto');

    //add background effect
  var $header =  $('#header')
  if($header.hasClass('transparent')){
      var scroll = $(window).scrollTop();
      if (scroll < 2 && $header.hasClass('scrolling') ) {
        $header.removeClass('scrolling');
      }   
   }
  }, timedelay);
}

function mobile_slide_left(link) {

  var timedelay = 300;

  var nav_container = link.closest('.header-mobile-container');
  var nav_container_inner = nav_container.find('.header-mobile-container-inner');

  target = link.closest('li.nav-item');
  target.addClass('sub-active');
  set_nav_height = target.find('.sub-nav > .sub-nav-inner').height();

  $('.header-mobile-container').animate({
    scrollTop: $('.header-mobile-container').offset().top - 400 /// over set neg number to force to the top on any screen size
  }, timedelay);

  setTimeout(function () {
    nav_container.addClass('sub-open');
    nav_container_inner.addClass('slide-left').height(set_nav_height);
  }, timedelay);

}

// Resize mobile sub nav height on window resize
$(document).ready(function () {
  $(window).on("resize", function () {
    if ($(window).width() < '1024') {
      var nav_container = $('.header-mobile-container-inner');
      set_resized_nav_height = $('li.nav-item.sub-active').find('.sub-nav > .sub-nav-inner').height();
      if (nav_container.hasClass('slide-left')) {
        nav_container.height(set_resized_nav_height)
      }
    }
  });
});

function mobile_slide_back(link) {
  var nav_container = link.closest('.header-mobile-container');
  var nav_container_inner = nav_container.find('.header-mobile-container-inner');

  $('header.header-mega_menu .header-mobile-container ul li.nav-item').each(function () {
    $(this).removeClass('sub-active');
  });

  nav_container.removeClass('sub-open');
  nav_container_inner.removeClass('slide-left').height('auto');
}


function lang_menu_open() {
  $('.header-mobile-country-select-container').addClass('open');
  $('header.header-mega_menu .btn-country-select').addClass('menu-open');
}

function lang_menu_close() {
  $('.header-mobile-country-select-container').removeClass('open');
  $('header.header-mega_menu .btn-country-select').removeClass('menu-open');
}